// @need-translate
import {forwardRef} from 'react';
import {UrlLink} from '../../../applink/UrlLink';
import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {Grid} from '../../atoms/Grid/Grid';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {Toggle} from '../../atoms/Toggle/Toggle';
import {IconTextBox} from '../../molecules/IconTextBox/IconTextBox';
import {CashContainer} from '../CashContainer/CashContainer';
import {PcProfileMenuProps} from './PcProfileMenuProps.interface';

export const PcProfileMenu = forwardRef<HTMLDivElement, PcProfileMenuProps>(
  (
    {
      profileMenuList,
      nickname,
      cash,
      onClickNickname,
      onClickCashCharge,
      onClickMenuItem,
      onClickLogout,
      onClickToggleColorMode,
      isDarkMode,
      autoPaymentInfo,
      className,
      ...props
    }: PcProfileMenuProps,
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={twMerge(
          'flex h-478pxr w-276pxr flex-col items-center rounded-8pxr border-1 border-solid border-theme-transparent-10 bg-theme-bg-surface px-15pxr pt-23pxr shadow-round dark:shadow-none',
          className
        )}
        {...props}
      >
        <UrlLink url="/account/info">
          <div
            onClick={onClickNickname}
            className="mb-16pxr flex max-w-212pxr cursor-pointer flex-row items-center justify-center rounded-18pxr border-1 border-solid border-theme-transparent-20 py-9pxr pr-8pxr pl-16pxr text-theme-solid-100"
          >
            <Text className="font-small2 text-ellipsis break-all line-clamp-1">
              {nickname}
            </Text>
            <Text className="font-small2">님</Text>
            <Icon type={IconType.ButtonArrowRight} disableActiveEffect />
          </div>
        </UrlLink>
        <CashContainer
          cash={cash}
          autoPaymentInfo={autoPaymentInfo}
          onClickCashCharge={onClickCashCharge}
        />
        <Grid cols={3} gapPx={0} className="pt-24pxr">
          {profileMenuList.map((menu, idx) => (
            <UrlLink url={menu.href} key={idx}>
              <IconTextBox
                iconType={menu.icon}
                label={menu.title}
                hasDot={menu.hasDot}
                className="mb-24pxr h-48pxr w-76pxr cursor-pointer"
                textClassName="mt-8pxr"
                onClick={e => onClickMenuItem(menu, e)}
              />
            </UrlLink>
          ))}
        </Grid>
        <div
          className="flex h-56pxr w-full flex-row items-center justify-between border-y-1 border-theme-transparent-10 px-8pxr"
          {...putTiaraObjectProps({
            // 토글 후의 결과값을 보내야 하므로 반대로 넣어줍니다. (true일 때 토글 결과 다크모드 off가 됨)
            click: {copy: isDarkMode ? 'OFF' : 'ON'},
          })}
        >
          <div className="flex items-center">
            <Icon
              type={IconType.MenuColorMode}
              className="mr-6pxr"
              disableActiveEffect
            />
            <Text className="font-medium2 text-theme-solid-100">
              {t('more_settings_screen_type_dark')}
            </Text>
          </div>
          <Toggle
            isActive={isDarkMode}
            onClickToggle={onClickToggleColorMode}
            className="h-24pxr w-44pxr px-2pxr"
          />
        </div>
        <div
          className="flex w-full cursor-pointer items-center justify-center"
          onClick={onClickLogout}
        >
          <Text className="font-small1 py-19pxr text-center text-theme-solid-60">
            {t('common_logout')}
          </Text>
        </div>
      </div>
    );
  }
);
PcProfileMenu.displayName = 'PcProfileMenu';
